import { proxy } from 'valtio';
import isEmpty from 'lodash/isEmpty';
import storeRematch from '@/store';

import * as versions from './versions';
import * as stratums from './stratums';
import * as period from './reporting-period';
import * as intervals from './intervals';

const relatedModels = [versions, stratums, period, intervals];

const msg = {
    stratums: 'Должен быть выбран как минимум один пласт',
    period: 'Поле с датой не может оставаться пустым',
};

/*
    Возможно, понадобится какое-то промежуточное состояние, поэтому - proxy.
*/
export const gosplan = proxy({
    init() {
        gosplan.resetDefaultGosplanParams();
        versions.actions.fetch();
    },
    /*
        Собираем необходимые параметры со всех связанных моделей
    */
    getGosplanParams() {
        const {
            tree: { calculationObject },
        } = storeRematch.getState();

        if (isEmpty(calculationObject)) return;

        const { id: fieldId, parentVentureId: ventureId } = calculationObject;

        const params = { fieldId, ventureId, objectId: fieldId };

        for (const model of relatedModels) {
            const modelParams = model.actions.getParams();
            Object.assign(params, modelParams);
        }

        return params;
    },
    /*
        Сброс параметров связанных моделей
    */
    resetDefaultGosplanParams() {
        for (const model of relatedModels) {
            if (model.actions.resetDefaultState) {
                model.actions.resetDefaultState();
            }
        }
    },
    /*
        Какая то валидация значений связанных моделей
    */
    validateModels() {
        const result = {
            isValid: true,
            error: '',
        };

        for (const model of relatedModels) {
            if (!model.validate) continue;

            const validationObject = model.validate.check();

            if (validationObject.isValid) continue;

            result.isValid = false;
            result.error = msg[validationObject.modelName] ?? 'Ошибка валидации';

            break;
        }

        return result;
    },
});
